// (2026-05-23) Splash universal mostrado durante la carga de cualquier
// documento publico via QR (factura, guia, retencion IVA / ISLR).
// Animacion "Sintesis estelar" — dos estrellas (Sirius A y B) convergen
// al centro y de la fusion emerge el logo Quantus Invoice. Pura HTML+CSS,
// sin libs externas. Respeta prefers-reduced-motion. Duracion ~2 s.
import React from "react";

// (2026-05-26 v17) URLs relativas: los logos se sirven desde el mismo
// dominio que aloja el frontend, así que basta con el path absoluto en
// la raíz del sitio. Desacopla el componente del dominio hardcodeado y
// lo hace adaptable a cambios de hosting sin rebuild del bundle CRA.
const SIRIUS_LOGO = "/sirius-logo.png";
const QUANTUS_LOGO = "/quantus-logo.png";

const PublicSplash = () => {
  return (
    <div className="qi-splash" role="presentation" aria-hidden="true">
      <div className="qi-stage">
        <div className="qi-orbit qi-orbit-a" />
        <div className="qi-orbit qi-orbit-b" />
        <div className="qi-star qi-star-a" />
        <div className="qi-star qi-star-b" />
        <div className="qi-burst" />
        <div className="qi-brand-wrap">
          <div className="qi-brand">
            <img src={QUANTUS_LOGO} alt="Quantus Invoice" className="qi-quantus" />
            <div className="qi-by">
              <span>by</span>
              <img src={SIRIUS_LOGO} alt="Sirius Solutions" className="qi-sirius" />
            </div>
          </div>
        </div>
      </div>
      <div className="qi-tagline">Tu factura, en tiempo real</div>
      <div className="qi-powered">Powered by Sirius Solutions</div>

      <style>{`
        .qi-splash {
          position: fixed; inset: 0;
          background: radial-gradient(ellipse at center, #1e1b4b 0%, #0a0e1a 70%, #050810 100%);
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          z-index: 9999; overflow: hidden;
          font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
          animation: qi-splash-out 350ms ease-in 1900ms forwards;
        }
        .qi-stage { position: relative; width: 320px; height: 320px; }
        .qi-orbit {
          position: absolute; top: 50%; left: 50%;
          width: 240px; height: 100px;
          border-radius: 50%; pointer-events: none;
          transform: translate(-50%, -50%);
        }
        .qi-orbit-a { border: 1px solid rgba(167,139,250,0.20); }
        .qi-orbit-b { border: 1px solid rgba(240,171,252,0.16);
                      transform: translate(-50%, -50%) rotate(60deg); }
        .qi-star {
          position: absolute; top: 50%; left: 50%;
          width: 28px; height: 28px; margin: -14px 0 0 -14px;
          border-radius: 50%; opacity: 0;
        }
        .qi-star-a {
          background: radial-gradient(circle, #ede9fe 0%, #7c3aed 55%, rgba(124,58,237,0) 100%);
          box-shadow: 0 0 24px 8px rgba(124,58,237,0.55);
          animation: qi-orbit-a 1.2s cubic-bezier(.4,0,.2,1) 250ms forwards;
        }
        .qi-star-b {
          background: radial-gradient(circle, #fbcfe8 0%, #a21caf 55%, rgba(162,28,175,0) 100%);
          box-shadow: 0 0 24px 8px rgba(162,28,175,0.55);
          animation: qi-orbit-b 1.2s cubic-bezier(.4,0,.2,1) 250ms forwards;
        }
        .qi-burst {
          position: absolute; top: 50%; left: 50%;
          width: 0; height: 0; border-radius: 50%; opacity: 0;
          background: radial-gradient(circle, #ffffff 0%, #c4b5fd 38%, rgba(124,58,237,0) 78%);
          transform: translate(-50%, -50%);
          animation: qi-burst 480ms ease-out 1300ms forwards;
        }
        .qi-brand-wrap {
          position: absolute; top: 50%; left: 50%;
          transform: translate(-50%, -50%); pointer-events: none;
        }
        .qi-brand {
          display: flex; flex-direction: column; align-items: center; gap: 8px;
          opacity: 0; transform: translateY(8px);
          animation: qi-fade-up 500ms ease-out 1500ms forwards;
        }
        .qi-quantus { max-width: 240px; height: auto;
          filter: drop-shadow(0 6px 16px rgba(0,0,0,0.5)); }
        .qi-by {
          color: #cbd5e1; font-size: 12px; letter-spacing: 0.04em;
          display: flex; align-items: center; gap: 6px;
        }
        .qi-by span { opacity: 0.85; }
        .qi-sirius {
          height: 20px; width: auto; opacity: 0.95;
          /* Logo Sirius original es oscuro; se invierte para fondo oscuro. */
          filter: invert(1) brightness(1.4);
        }
        .qi-tagline {
          position: absolute; bottom: 64px; left: 0; right: 0; text-align: center;
          color: #e2e8f0; font-size: 16px; font-weight: 600; letter-spacing: 0.01em;
          opacity: 0; transform: translateY(6px);
          animation: qi-fade-up 500ms ease-out 1750ms forwards;
        }
        .qi-powered {
          position: absolute; bottom: 28px; left: 0; right: 0; text-align: center;
          color: #94a3b8; font-size: 11px; letter-spacing: 0.10em; text-transform: uppercase;
          opacity: 0;
          animation: qi-fade 500ms ease-out 1900ms forwards;
        }
        @keyframes qi-orbit-a {
          0%   { transform: translate(140px, 0) scale(0.4); opacity: 0; }
          20%  { opacity: 1; }
          70%  { transform: translate(20px, 0)  scale(1.0); opacity: 1; }
          95%  { transform: translate(0, 0)     scale(0.3); opacity: 0; }
          100% { transform: translate(0, 0)     scale(0);   opacity: 0; }
        }
        @keyframes qi-orbit-b {
          0%   { transform: translate(-140px, 0) scale(0.4); opacity: 0; }
          20%  { opacity: 1; }
          70%  { transform: translate(-20px, 0)  scale(1.0); opacity: 1; }
          95%  { transform: translate(0, 0)      scale(0.3); opacity: 0; }
          100% { transform: translate(0, 0)      scale(0);   opacity: 0; }
        }
        @keyframes qi-burst {
          0%   { width: 0; height: 0; opacity: 0; }
          40%  { width: 260px; height: 260px; opacity: 1; }
          100% { width: 500px; height: 500px; opacity: 0; }
        }
        @keyframes qi-fade-up {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: none; }
        }
        @keyframes qi-fade {
          from { opacity: 0; } to { opacity: 1; }
        }
        @keyframes qi-splash-out {
          from { opacity: 1; visibility: visible; }
          to   { opacity: 0; visibility: hidden; }
        }
        @media (prefers-reduced-motion: reduce) {
          .qi-splash, .qi-star, .qi-burst, .qi-brand, .qi-tagline, .qi-powered {
            animation: none !important;
            opacity: 1 !important;
            transform: translate(-50%, -50%) !important;
          }
          .qi-star, .qi-burst, .qi-orbit { display: none; }
        }
      `}</style>
    </div>
  );
};

export default PublicSplash;
